module.exports = __webpack_public_path__ + "media/images/OPL 33-f39f71cc319310a7bb7da23274c3c00f.png";